import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-responsive";
import { Link, useNavigate } from "react-router-dom";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { PAGES } from "../../../routeConfig";
import { useAuth } from "../../../Context/AuthContext";
import { useOrderClarificationModal } from "../../../Context/OrderClarificationPopUpContext";
import { axiosInstance } from "../../../axios/axiosInstance";
import { isValidArray } from "../../../Layout/Common/common";
const esc = (v) =>
  String(v ?? "").replace(
    /[&<>"']/g,
    (c) =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
      })[c],
  );
export const PendingOrderHistoryTable = ({ data }) => {
  const tableRef = useRef(null);
  const dtRef = useRef(null);
  const navigate = useNavigate();
  const { deleteOrderHistory, getPendingOrderHistory } = useGlobalFunction();
  const { showDialogAlert, hideNoteAlert } = useNoteAlert();
  const { userId, role } = useAuth();
  const { showOrderClarification } = useOrderClarificationModal();

  useEffect(() => {
    const $table = $(tableRef.current);
    function markFirstVisible() {
      $table.find("tbody tr").each(function () {
        const $cells = $(this).children("td").removeClass("orderCustomClass");
        const $firstVisible = $cells
          .filter(function () {
            const $td = $(this);
            return $td.is(":visible") && !$td.hasClass("dtr-hidden");
          })
          .first();
        $firstVisible.addClass("orderCustomClass");
      });
    }
    dtRef.current = $table.DataTable({
      data: [],
      columns: [
        {
          data: null,
          title: "S NO",
          render: (data, type, row, meta) => {
            return meta.row + 1;
          },
        },
        { data: "user", defaultContent: "" },
        {
          data: "orderDate",
          render: (v) => `<p class="order-date">${v ?? ""}</p>`,
        },
        {
          data: "custOrderNo",
          defaultContent: "",
        },
        {
          data: null,
          orderable: false,
          render: (value, type, row) => {
            const orderId = esc(row.orderId);
            const viewRef = esc(row.url_ref);
            return `
      <div class="orders-button">
      ${
        role != "3"
          ? `      <a class="pendingOrder-edit js-view-Approveorder" role="button" tabindex="0"
           data-order-ref="${viewRef}" data-order-id="${orderId}" aria-label="Approve order">
          <span class="fas fa-check-circle" aria-hidden="true"></span>
          <span class="action-menus">Approve Order</span>
        </a>`
          : ""
      }
        <a class="pendingOrder-edit js-view-order" role="button" tabindex="0"
           data-order-id="${viewRef}" aria-label="View or edit order">
          <span class="wes-eye" aria-hidden="true"></span>
          <span class="action-menus">View / Edit</span>
        </a>
        <div class="button-effect pendingOrder-trash">
          <button type="button" class="btn js-delete-order"
                  data-order-id="${orderId}" aria-label="Delete order">
            <span class="wes-trash" aria-hidden="true"></span>
            <span class="action-menus">Delete</span>
          </button>
        </div>
      </div>`;
          },
        },
      ],
      language: {
        paginate: {
          previous: '<i class="fa fa-chevron-left"></i>',
          next: '<i class="fa fa-chevron-right"></i>',
        },
      },
      responsive: { details: { type: "column", target: "tr" } },
      autoWidth: false,
      searching: false,
      columnDefs: [
        { targets: [4], orderable: false },
        { targets: [2, 3], className: "orderListing", responsivePriority: 3 },
      ],
      drawCallback: () => markFirstVisible(),
    });
    $table.on("responsive-resize.dt", () => markFirstVisible());
    markFirstVisible();
    $table.on("click", ".js-view-order", function () {
      const orderId = $(this).data("order-id");
      navigate(`/myaccount/pending-orders/${orderId}`);
    });
    $table.on("click", ".js-view-Approveorder", async function () {
      const $btn = $(this);
      if ($btn.hasClass("is-validating")) return;
      const orderId = $btn.data("order-id");
      const orderRef = $btn.data("order-ref");
      const originalHtml = $btn.html();
      $btn
        .addClass("is-validating")
        .attr("aria-busy", "true")
        .css("pointer-events", "none")
        .html(
          '<span class="fa fa-spinner fa-spin" aria-hidden="true"></span>' +
            '<span class="action-menus">Validating...</span>',
        );
      try {
        await onApproveOrder(orderId, orderRef);
      } finally {
        $btn.removeClass("is-validating").removeAttr("aria-busy").css("pointer-events", "").html(originalHtml);
      }
    });
    $table.on("click", ".js-delete-order", async function () {
      const oid = $(this).data("order-id");
      const incNo = $(this).data("invoice-no");
      handleDeleteClick(String(oid));
    });
    return () => {
      dtRef.current?.destroy(true);
      dtRef.current = null;
    };
  }, []);

  const loadPendingOrder = async () => {
    try {
      var response = await getPendingOrderHistory();
      hideNoteAlert();
      renderTable(response);
    } catch (e) {
      console.error(e);
    }
  };

  const onApproveOrder = async (orderId, orderRef) => {
    try {
      const response = await axiosInstance.post("MyCart/GetOrderClarification", {
        userId: String(userId),
        orderId: String(orderId),
      });
      if (response.data) {
        let res = response.data;
        if (res.statusCode != -1 && isValidArray(res.data)) {
          navigate(`/myaccount/pending-orders/${orderRef}`);
        } else navigate(`/checkout/${orderId}`);
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    renderTable(data);
  }, [data]);

  const renderTable = (raw) => {
    const dt = dtRef.current;
    if (!dt) return;
    dt.clear();
    if (Array.isArray(raw)) dt.rows.add(raw);
    dt.draw(true);
  };

  const handleDeleteClick = (orderId) => {
    showDialogAlert({
      content: "Do you want to delete this order permanently?",
      title: "Delete Confirmation",
      primaryBtn: {
        caption: "Yes, Remove",
        onClick: () => orderDeletefun(orderId),
      },
      scondaryBtn: {
        caption: "Cancel",
        onClick: hideNoteAlert,
      },
    });
  };

  const orderDeletefun = async (oid) => {
    let response = await deleteOrderHistory({ orderId: String(oid) });
    if (response) {
      loadPendingOrder();
    }
  };

  return (
    <table
      ref={tableRef}
      className="table table-striped display nowrap orderlist-table dataTable no-footer dtr-column"
      style={{ width: "100%" }}
    >
      <thead>
        <tr>
          <th>S NO</th>
          <th>User Name</th>
          <th>Order Date</th>
          <th>Cust. Order Number</th>
          <th></th>
        </tr>
      </thead>
      <tbody />
    </table>
  );
};
